export default "__VITE_ASSET__b6d5648d__"